import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/common/constants/routes';
import { DiscountsList as CommonDiscountsList } from '@/common/containers/Dashboard/DiscountsPage/components/DiscountsList/DiscountsList';
import { AnalyticsService } from '@/common/integrations/analytics/analytics.service';
import { IDiscount } from '@/common/integrations/menhir/employee/discounts/discounts.types';
import { ListSection } from '@/web/components/ListSection/ListSection';

interface IProps {
  discounts: IDiscount[];
  className?: string;
  context:
    | 'wallet_page'
    | 'meal_page'
    | 'benefit_details_page'
    | 'discounts_page';
}

export const DiscountsList = ({ discounts, context, className }: IProps) => {
  const { t } = useTranslation();
  const listElement = <CommonDiscountsList discounts={discounts} />;

  if (context !== 'discounts_page') {
    return (
      <ListSection
        title={t('wallet.discounts.title')}
        className={className}
        onClick={() => {
          AnalyticsService.trackCustomEvent(
            'discounts_see_all_button_clicked',
            {
              context,
            }
          );
        }}
        seeAllRoute={ROUTES.DISCOUNTS}
      >
        {listElement}
      </ListSection>
    );
  }

  return listElement;
};
